import axios from "axios";

export interface AddCommentProps {
  commentOn: number;
  parentId?: number;
  content: string;
  token: string;
}

export const addComment = async ({
  commentOn,
  parentId,
  content,
  token,
}: AddCommentProps) => {
  try {
    const resp = await axios.post("/api/user/createcomment", {
      commentOn,
      parentId,
      content,
      token,
    });
    return resp;
  } catch (e) {
    console.log("error adding Comment: ", e);
    return false;
  }
};
